/*
 * @Author: Chao Yang
 * @Date: 2020-01-17 09:43:12
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-01-17 09:46:18
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InterceptorModule } from './interceptor';
import { ServiceModule } from './service';

@NgModule({
  declarations: [],
  imports: [CommonModule, InterceptorModule, ServiceModule]
})
export class InfrastructureModule {}
